import { message } from "antd";
import { lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import CvsNativeReturn from "./pages/Commons/CvsPayment/CvsNativeReturn";
import QA from "./pages/Commons/QA";
import { appRoutes } from "./router/routes";

const BuyVoucher = lazy(() => import("./pages/PremiumVoucher/BuyVoucher"));
const BankTransferAccount = lazy(() => import("./pages/Commons/BankTransferAccount"));
const PaymentResult = lazy(() => import("./pages/Commons/PaymentResult"));
const CvsRedirect = lazy(() => import("./pages/Commons/CvsPayment/CvsRedirect"));
const CvsCallback = lazy(() => import("./pages/Commons/CvsPayment/CvsCallback"));
const HistoryUseDetail = lazy(
    () => import("./pages/PremiumVoucher/HistoryUseDetail")
);
const HistoryBuyDetail = lazy(
    () => import("./pages/PremiumVoucher/HistoryBuyDetail")
);
const HistoryLotteryDetail = lazy(
    () => import("./pages/PremiumVoucher/HistoryLotteryDetail")
);
const PostCode = lazy(() => import("./pages/PremiumVoucher/PostCode"));
const PremiumVouchersList = lazy(
    () => import("./pages/PremiumVoucher/PremiumVouchersList")
);
const SearchVoucher = lazy(() => import("./pages/PremiumVoucher/Search"));

const SuccessfulUseVoucher = lazy(
    () => import("./pages/PremiumVoucher/SuccessfulUseVoucher")
);
const PremiumBenefits = lazy(() => import("./pages/PremiumVoucher/Top"));
const VoucherPayment = lazy(
    () => import("./pages/PremiumVoucher/VoucherPayment")
);
const VoucherRelease = lazy(
    () => import("./pages/PremiumVoucher/VoucherRelease")
);
const History = lazy(() => import("./pages/PremiumVoucher/History"));
const VoucherSuccessNotification = lazy(
    () => import("./pages/PremiumVoucher/VoucherSuccessNotification")
);
const WhatIsPremiumVoucher = lazy(
    () => import("./pages/PremiumVoucher/VoucherWhatIs")
);

const CheckLottery = lazy(() => import("./pages/PremiumVoucher/CheckLottery"));
const PrivateRoute = lazy(() => import("./router/privateRoute"));
const MainPremiumVoucher = lazy(() => import("./layout/MainPremiumVoucher"));

const Login = lazy(() => import("./pages/Commons/Login"));
const Register = lazy(() => import("./pages/Commons/Register"));
const ListStores = lazy(() => import("./pages/PremiumVoucher/Stores"));
const Terms = lazy(() => import("./pages/PremiumVoucher/Terms"));
const Notifications = lazy(
    () => import("./pages/PremiumVoucher/Notifications")
);
const NotificationDetail = lazy(
    () => import("./pages/PremiumVoucher/NotificationDetail")
);
const VoucherDetail = lazy(
    () => import("./pages/PremiumVoucher/VoucherDetail")
);
const InfoMember = lazy(() => import("./pages/Commons/InfoMember"));
const ResetPassword = lazy(() => import("./pages/Commons/ResetPassword"));
const NotFound = lazy(() => import("./pages/Commons/NotFound"));
const FontSizeSetting = lazy(() => import("./pages/Commons/FontSizeSetting"));
const MyNumberCallback = lazy(
    () => import("./pages/Commons/MyNumberCallback")
);
function App() {
  message.config({
    top: 40,
  });
  return (
      <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
        <Routes>
          <Route
              path={`${appRoutes.PREMIUM_VOUCHER.ROOT}/${appRoutes.PREMIUM_VOUCHER.MY_NUMBER_CALLBACK}`}
              element={<MyNumberCallback />}
          />
          <Route
              path={`${appRoutes.PREMIUM_VOUCHER.ROOT}/${appRoutes.PREMIUM_VOUCHER.CVS_CALLBACK}/app/:result`}
              element={<CvsNativeReturn />}
          />
          <Route
              path={`${appRoutes.PREMIUM_VOUCHER.ROOT}`}
              element={<PrivateRoute />}
          >
            <Route element={<MainPremiumVoucher />}>
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.SUCCESS_NOTIFICATION}`}
                  element={<VoucherSuccessNotification />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.RELEASE}`}
                  element={<VoucherRelease />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.WHAT_IS}`}
                  element={<WhatIsPremiumVoucher />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.TOP}`}
                  element={<PremiumBenefits />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.POST_CODE}`}
                  element={<PostCode />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.LIST_VOUCHER}`}
                  element={<PremiumVouchersList />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.CHECK_LOTTERY}`}
                  element={<CheckLottery />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.VOUCHER_DETAIL}/:id`}
                  element={<VoucherDetail />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.PAYMENT}`}
                  element={<VoucherPayment />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.BANK_TRANSFER_INFO}/:paymentId`}
                  element={<BankTransferAccount />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.BANK_TRANSFER_RESULT}/:status`}
                  element={<PaymentResult />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.PAYMENT_SUCCESS}`}
                  element={<PaymentResult resultStatus="success" />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.PAYMENT_FAILED}`}
                  element={<PaymentResult resultStatus="expired" />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.CVS_REDIRECT}`}
                  element={<CvsRedirect />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.CVS_CALLBACK}/:result`}
                  element={<CvsCallback />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.SEARCH}`}
                  element={<SearchVoucher />}
              />

              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.INFO_MEMBER}`}
                  element={<InfoMember />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.HISTORY}`}
                  element={<History />}
              />

              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.HISTORY_USE_DETAIL}`}
                  element={<HistoryUseDetail />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.HISTORY_DETAIL}`}
                  element={<HistoryBuyDetail />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.HISTORY_LOTTERY_DETAIL}`}
                  element={<HistoryLotteryDetail />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.SUCCESSFUL_USE}`}
                  element={<SuccessfulUseVoucher />}
              />
              <Route path={`${appRoutes.PREMIUM_VOUCHER.QA}`} element={<QA />} />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.LOGIN}`}
                  element={<Login />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.REGISTER}`}
                  element={<Register />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.LIST_STORES}`}
                  element={<ListStores />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.TERMS}`}
                  element={<Terms />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.NOTIFICATIONS}`}
                  element={<Notifications />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.NOTIFICATIONS}/:notification_id`}
                  element={<NotificationDetail />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.BUY_VOUCHER}`}
                  element={<BuyVoucher />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.RESET_PASSWORD}`}
                  element={<ResetPassword />}
              />
              <Route
                  path={`${appRoutes.PREMIUM_VOUCHER.FONT_SIZE_SETTING}`}
                  element={<FontSizeSetting />}
              />
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
